import React from 'react';
import { Field, useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';

import { DynmicFormFieldTypeOptions } from '../../config/DynmicFormFieldType';
import { InputUI, FormErrorUI, FormLabelUI, SelectUI, DialogUI, ButtonUI } from '../Interface';
const DynamicFormCreatorDynFieldsDialog = (props) => {
  const { selectedIndex, open, onClose, viewField, selectedValuesState, remove } = props;
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  const { selectedValues } = selectedValuesState;

  return (
    <DialogUI open={open} onClose={onClose} headerContent={'Mezők'} maxWidth="md" fullWidth>
      <Grid container spacing={2} sx={{ alignItems: 'center', mt: 1 }}>
        <Grid item xs={12} md={6}>
          <Field
            type="text"
            name={`dynamicFormField.[${selectedIndex}].name`}
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Megnevezés" />}
            variant="standard"
            helperText={<FormErrorUI message={errors?.dynamicFormField?.[selectedIndex]?.name} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.dynamicFormField?.[selectedIndex]?.name !== '' }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            name={`dynamicFormField.[${selectedIndex}].type`}
            component={SelectUI}
            fullWidth
            option={DynmicFormFieldTypeOptions}
            value={values?.dynamicFormField?.[selectedIndex]?.type ?? ''}
            variant="standard"
            onChange={(e) => {
              const value = e.target.value;
              setFieldValue(`dynamicFormField.[${selectedIndex}].type`, value ?? null).then(() => {
                validateField(`dynamicFormField.[${selectedIndex}].type`);
              });

              setFieldValue(`dynamicFormField.[${selectedIndex}].staticText`, '');
            }}
            label={<FormLabelUI text="Típus" />}
            helperText={<FormErrorUI message={errors?.dynamicFormField?.[selectedIndex]?.type} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.type !== '' || values.type !== null }}
          />
        </Grid>
        {/* statikus input box */}
        <Grid item xs={12} md={12}>
          {values?.dynamicFormField?.[selectedIndex]?.type === 'STATIC' && (
            <Field
              type="text"
              name={`dynamicFormField.[${selectedIndex}].staticText`}
              as={InputUI}
              fullWidth
              label={<FormLabelUI text="Statikus szöveg" />}
              variant="standard"
              helperText={<FormErrorUI message={errors?.dynamicFormField?.[selectedIndex]?.staticText} />}
              disabled={viewField}
              InputLabelProps={{ shrink: values.dynamicFormField?.[selectedIndex]?.staticText !== '' }}
              multiline
              rows={4}
            />
          )}
        </Grid>
        <Grid item xs={12} md={2}>
          <Field
            type="number"
            name={`dynamicFormField.[${selectedIndex}].visOrder`}
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Sorrend" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.dynamicFormField?.[selectedIndex]?.visOrder} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.dynamicFormField?.[selectedIndex]?.visOrder !== '' }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ px: 4, mt: 8, justifyContent: 'center' }}>
        <Grid item>
          <ButtonUI text="Mentés" className="bg-success" type="button" onClick={onClose} />
        </Grid>
        <Grid item>
          <ButtonUI
            text="Mégse"
            className=""
            color="blue-gray"
            type="button"
            variant="gradient"
            onClick={() => {
              const findedValue = selectedValues.dynamicFormField.find(
                (item) => item.id === values?.dynamicFormField[selectedIndex].id
              );

              if (findedValue) {
                setFieldValue(`dynamicFormField.[${selectedIndex}]`, findedValue);
                validateField(`dynamicFormField.[${selectedIndex}]`);
              } else {
                remove(selectedIndex);
              }
              onClose();
            }}
          />
        </Grid>
      </Grid>
    </DialogUI>
  );
};

export default DynamicFormCreatorDynFieldsDialog;
